import { styled } from "@mui/material";
import {
  MOBILE_SCREEN_SIZE,
  TABLET_SCREEN_SIZE,
} from "../../../../../AppNavigation/constants";

const PillContainer = styled("div", {
  label: "SurveyPillContainer",
})(({ theme }) => ({
  backgroundColor: "#f6f8fa",
  borderRadius: 999,

  border: `1px solid transparent`, // prevent size change when selected
  boxSizing: "border-box",

  height: 46,
  padding: "0px 18px",

  transition: "all 0.3s",
  cursor: "pointer",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  [`@media (max-width: ${TABLET_SCREEN_SIZE}px)`]: {},
  [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
    height: 36,
  },

  "&.selected": {
    border: `1px solid ${theme.vars.palette.primary.main}`,
    background: theme.vars.palette.primary.main,
    ".row_text": { color: "#fff" },
  },

  ".row_text": {
    flex: 1,
    fontSize: 16,
    textAlign: "center",
    fontWeight: 600,
    color: theme.vars.palette.text.primary,
    [`@media (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
      fontSize: 16,
    },
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      fontSize: 12,
    },
  },
  ".indicator": {
    marginLeft: 10,
    width: 23,
    height: 23,
    objectFit: "contain",
    [`@media (max-width: ${TABLET_SCREEN_SIZE}px)`]: {},
    [`@media (max-width: ${MOBILE_SCREEN_SIZE}px)`]: {
      width: 18,
      height: 18,
    },
  },

  "&.disabled": {
    ".row_text": {
      opacity: 0.5,
    },
  },
}));

export const SurveyPill = ({
  text,
  onClick,
  selected = false,
  disabled = false,
}: {
  text: string;
  onClick: () => void;
  selected?: boolean;
  disabled?: boolean;
}) => {
  return (
    <PillContainer
      className={`${disabled ? "disabled" : ""} ${selected ? "selected" : ""}`}
      onClick={onClick}
    >
      <div className="row_text">{text}</div>
    </PillContainer>
  );
};

export default SurveyPill;
